// Internal Errors

export const errorMessageRolesRoleNotFound = 'Role not found.';
export const errorMessageRolesDefaultDelete = 'The default role cannot be deleted.';
export const errorMessageRolesDefaultChange = 'The default role cannot be changed to non-default.';
export const errorMessageRolesAnonymousDelete = 'The anonymous role cannot be deleted.';
export const errorMessageRolesAnonymousChange = 'The anonymous role cannot be changed to non-anonymous.';
export const errorMessageRolesNonAnonymousChange = 'A non-anonymous role cannot be changed to anonymous.';
export const errorMessageRolesAnonymousPages = 'Pages cannot be assigned to an anonymous role.';
export const errorMessageRolesAnonymousCreate = 'Anonymous roles cannot be created.';
export const errorMessageRolesAdminChange = 'The admin role cannot be edited.';
export const errorMessageRolesAdminDelete = 'The admin role cannot be deleted.';
export const errorMessageRolesRoleInUse = 'A role assigned to a user cannot be deleted.';

// Responses

export const errorResponseRolesFetch = 'Role fetching failed; Invalid parameters.';
export const errorResponseRolesDelete = 'Role delete failed; Role not found.';
export const errorResponseRolesCreate = 'Role create failed; Invalid parameters.';
export const errorResponseRolesUpdate = 'Role update failed; Role not found or invalid data.';
export const errorResponseRolesBulkDelete = 'Role bulk delete failed; Invalid data.';
